import React from 'react';
import HeroSection from './HeroSection';

function Home() {
  return (
    <div id="home" className="content">
      
      <HeroSection />
      <div></div>
    </div>
  );
}

export default Home;